/* eslint-disable i18n-scan/no-inline-content */
import {
  BodyText,
  CaptionText,
  Card,
  Col,
  HeadingText,
  Row,
} from '@paypalcorp/pp-react'
import { isEmpty } from 'lodash-es'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import React, { useContext } from 'react'
import { toCommaSeparatedNumber } from '../__utils__'
import { OfferContext } from './offerContext'
/**
 * This is a functional component that display list of offer header
 * @returns {JSX.Element} - A JSX element
 */

const OfferHeader: React.FC = () => {
  const {
    offerMaxAmount,
    previousLoanOutstandingAmount,
    previousLoans,
    renewalStatus,
  } = useContext(OfferContext)

  const captionText =
    renewalStatus === 'LOAN_RENEWAL' && !isEmpty(previousLoans)
      ? interpolate(
          getLocalizedText('offer-page.offerHeader.captionTextRenewal'),
          {
            prevRemainingAmount: (
              <span style={{ fontWeight: 'bold' }}>
                ${toCommaSeparatedNumber(previousLoanOutstandingAmount)}
              </span>
            ),
          },
        )
      : getLocalizedText('offer-page.offerHeader.captionText')

  return (
    <div className="headerContainer">
      <HeadingText className="headerTitleDesktop" level={1}>
        {getLocalizedText('offer-page.offerHeader.title')}
      </HeadingText>
      <HeadingText className="headerTitleMobile" level={2}>
        {getLocalizedText('offer-page.offerHeader.title')}
      </HeadingText>
      <Card className="headerCardWrapper">
        <div id="reconfigurator-header">
          <Row>
            <Col xs={3} md={2}>
              <img
                src="https://www.paypalobjects.com/paypal-ui/pictograms/multicolored/svg/award-achieved.svg"
                alt="award-recieved"
              />
            </Col>
            <Col className="headerText" xs={9} md={10}>
              <BodyText className="horizontalBreak">
                {interpolate(
                  getLocalizedText('offer-page.offerHeader.headingText'),
                  {
                    maxAmount: (
                      <span style={{ fontWeight: 'bold' }}>
                        ${toCommaSeparatedNumber(offerMaxAmount)}!
                      </span>
                    ),
                  },
                )}
              </BodyText>
              <CaptionText>{captionText}</CaptionText>
            </Col>
          </Row>
        </div>
      </Card>
    </div>
  )
}

export default OfferHeader
